import { GET_AREA, GET_CATEGORIES, GET_CATEGORY_PRODUCTS, GET_CITY, GET_COUNTRIES, GET_PICKUP, GET_PRODUCT, SEARCH, SELECTED_BRANCH, SELECT_CATEGORY, STORE_DATA, STORE_LOGO, STORE_TIMING, UPDATE_DATA_STATE, GET_SOCIAL_ICON, MAKE_ORDER, GET_ORDER_CHECK_STATUS, CHECK_ORDER, GET_PROMOTION_BANNERS, GET_PROMOTION, GET_PINNED_BOX } from "redux/constants/fetchedData";

export const getLogo = (data) => templateAction(STORE_LOGO, data);
export const getSearchResult = (data) => templateAction(SEARCH, data);
export const getStoreData = (data) => templateAction(STORE_DATA, data);
export const getStoreTiming = (data) => templateAction(STORE_TIMING, data);
export const getCountries = (data) => templateAction(GET_COUNTRIES, data);
export const getCities = (data) => templateAction(GET_CITY, data);
export const getArea = (data) => templateAction(GET_AREA, data);
export const getPickup = (data) => templateAction(GET_PICKUP, data);
export const selectBranch = (data) => templateAction(SELECTED_BRANCH, data);
export const getCategories = (data) => templateAction(GET_CATEGORIES, data);
export const selectCategory = (data) => templateAction(SELECT_CATEGORY, data);
export const getCategoryProducts = (data) => templateAction(GET_CATEGORY_PRODUCTS, data);
export const getProduct = (data) => templateAction(GET_PRODUCT, data);
export const getSocialIcon = () => templateAction(GET_SOCIAL_ICON)
export const getOrderCheckStatus = (data) => templateAction(GET_ORDER_CHECK_STATUS, data);
export const makeOrder = (data) => templateAction(MAKE_ORDER, data)
export const checkOrder = (data) => templateAction(CHECK_ORDER, data)
export const getPromotionBanners = (data) => templateAction(GET_PROMOTION_BANNERS, data);
export const getPromotion = (data) => templateAction(GET_PROMOTION, data);
export const getPinnedBox = (data) => templateAction(GET_PINNED_BOX, data);

export const updateDataState = (data) => templateAction(UPDATE_DATA_STATE, data);

export const templateAction = (type, payload) => {
    return {
        type:type,
        payload:payload
    }
}